class ReviewsCustomSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    this.initSwiper();
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  initSwiper() {
    this.swiper = new Swiper(this.querySelector('.swiper'), {
      direction: 'horizontal',
      loop: false,
      slidesPerView: 'auto',
      navigation: {
        prevEl: this.querySelector('.reviews-custom__nav-prev'),
        nextEl: this.querySelector('.reviews-custom__nav-next')
      },
      pagination: {
        el: this.querySelector('.reviews-custom__pagination'),
        clickable: true
      }
    });
  }
}

customElements.define('reviews-custom-slider', ReviewsCustomSlider);
